export const THIRD_REPONSIBILITY = {
    title: '中国大地财产保险股份有限公司',
    subtitle: '家庭财产保险<br>附加承租人第三者责任保险条款',
    register_number: '（注册号：C00001030922018073010772）',
    protocols: [
        {
            intro: '保险责任',
            list: [
                {
                    order: '第一条',
                    context: '在保险期间内，被保险人承租的位于主险保险单载明地址的房屋内，由于被保险人及其家庭成员的一般过失行为导致意外事故的发生，造成第三者的人身伤亡和财产损失，依法应由被保险人承担的经济赔偿责任，保险人按照本附加险合同的约定负责赔偿。'
                },
                {
                    order: '第二条',
                    context: '保险事故发生后，被保险人因保险事故而被提起仲裁或诉讼的，对应由被保险人支付的仲裁或诉讼费用以及事先经保险人书面同意支付的其他必要的、合理的费用（以下统称“法律费用”），保险人按照本附加险合同的约定也负责赔偿。'
                }
            ]
        },
        {
            intro: '责任免除',
            list: [
                {
                    order: '第三条',
                    context: '下列任何原因造成的损失、费用，保险人不负责赔偿：',
                    details: [
                        { text: '（一）被保险人及其家庭成员、家政服务人员、暂居人员的故意行为、重大过失行为；' },
                        { text: '（二）自然灾害。' },
                        { text: '（三）管道安装、检修、试水、试压。' }
                    ]
                },
                {
                    order: '第四条',
                    context: '下列损失、费用，保险人不负责赔偿：',
                    details: [
                        { text: '（一）被保险人及其家庭成员、家政服务人员、暂居人员、出租人的人身伤亡和财产损失；' },
                        { text: '（二） 出租人的房屋及其室内附属设备、室内装潢、室内财产（含安装在房屋外的空调器和太阳能热水器等家用电器的室外设备）的损失;' },
                        { text: '（三）罚款、罚金及惩罚性赔偿；' },
                        { text: '（四）精神损害赔偿；' },
                        { text: '（五）间接损失；' },
                        { text: '（六）承租房屋被用于从事仓储、生产或经营性质的活动导致的赔偿责任；' },
                        { text: '（七）保险单载明的免赔额或按照保险单载明的免赔率计算的免赔额；' },
                        { text: '（八）其他不属于本保险责任范围内的损失、费用和责任。' }
                    ]
                }
            ]
        },
        {
            intro: '责任限额与免赔额（率）',
            list: [
                {
                    order: '第五条',
                    context: '本附加险的责任限额包括每次事故责任限额和累计责任限额，由投保人与保险人协商确定，并在保险单中载明。'
                },
                {
                    order: '第六条',
                    context: '每次事故免赔额（率）由投保人与保险人在签订本附加险合同时协商确定，并在保险单中载明。'
                }
            ]
        },
        {
            intro: '赔偿处理',
            list: [
                {
                    order: '第七条',
                    context: '保险人的赔偿以下列方式之一确定的被保险人的赔偿责任为基础：',
                    details: [
                        { text: '（一）被保险人和向其提出损害赔偿请求的受害方协商并经保险人确认；' },
                        { text: '（二）仲裁机构裁决；' },
                        { text: '（三）人民法院判决；' },
                        { text: '（四）保险人认可的其他方式。' }
                    ]
                },
                {
                    order: '第八条',
                    context: '发生保险责任范围内的损失，保险人按照以下方式计算赔偿：',
                    details: [
                        { text: '（一）保险人在扣除每次事故免赔额或按照保险单载明的每次事故免赔率计算的每次事故免赔额后在每次事故责任限额内计算赔偿，但对于人员死亡、残疾的赔偿不扣除上述每次事故免赔额；' },
                        { text: '（二）在保险期间内，保险人对多次事故承担的赔偿金额累计不超过累计责任限额。' }
                    ]
                },
                {
                    order: '第九条',
                    context: '除另有约定外，对每次事故法律费用的赔偿金额，保险人在第八条计算的赔偿金额以外按本附加险合同的约定另行计算，但保险人对每次事故承担的法律费用的赔偿金额不超过每次事故责任限额的10％。'
                }
            ]
        },
        {
            intro: '其他事项',
            list: [ { order: '第十条', context: '本附加险条款未尽事宜，以主险条款的约定为准；本附加险条款与主险条款若有相抵触之处，以本附加险条款的约定为准。' } ]
        },
        {
            intro: '释义',
            list: [ {context: '一般过失行为：指违反高于一般人或普通人的注意义务以上的注意义务。'} ]
        }
    ]
}